const appsPageSlugs = new Set(['list', 'quality-review', 'quality-stats', 'general-stats', 'app-logo-colors', 'app-fixer', 'stats']);

export default appsPageSlugs;
